import { render } from "./Section2.vue?vue&type=template&id=161b25bc"
import script from "./Section2.vue?vue&type=script&lang=js"
export * from "./Section2.vue?vue&type=script&lang=js"
script.render = render

export default script